module.exports = __webpack_public_path__ + "static/VIPGiftCard-97791536ba6ec269a64f44d70b4ff4cd.png";